import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {

    render() {
        this.props.init('cosmic-profile-report');
        return (
            <cosmic-profile />
        );
    }

}

const mapDispatchToProps = (dispatch) => ({
    init: (upc) => dispatch({ type: 'i-ching-reading:init', payload: { upc: upc } }),
});

export default connect(null, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/cosmic-profile.js